// Chip colours shared by the order view's panels, from the theme's state
// palette so they read in both themes.
export const TONES = {
  success: "bg-state-success-bg text-state-success-text",
  warning: "bg-state-warning-bg text-state-warning-text",
  danger: "bg-state-danger-bg text-state-danger-text",
  info: "bg-state-info-bg text-state-info-text",
  neutral: "bg-ui-surface-sunken text-ui-text-muted",
};

// A parcel's carrier status, coloured by what it means.
export const parcelTone = (status) => {
  const text = String(status ?? "").toLowerCase();
  if (!text) return "neutral";
  if (/deliver(ed|y complete)/.test(text) && !/attempt|fail|not/.test(text)) {
    return "success";
  }
  if (/exception|fail|return|cancel|lost|damag|refus|undeliver/.test(text)) {
    return "danger";
  }
  if (
    /transit|out for|picked|pickup|on (the )?way|arriv|depart|scan/.test(text)
  ) {
    return "info";
  }
  return "neutral";
};
